$(document).ready(function() {
    setTimeout(function() {
      if ($('.whatmore-base').length > 0 && $('.sub-collection-title').length > 0) {
        $('.whatmore-base').insertAfter('.sub-collection-title');
      }
    }, 100); 
  });

/* image lazy load 
  const images = document.querySelectorAll('img');
      images.forEach(img => {
        if (!img.hasAttribute('loading') || img.getAttribute('loading') !== 'lazy') {
          img.setAttribute('loading', 'lazy');
        }
      });*/

/* footer toogle */
 if ($(window).width() < 767){
       $('footer .footer-block__heading').each(function(){
          $(this).click(function(){
              $(this).siblings('.footer-block__details-content').slideToggle()
          })
       })
      }

$(window).scroll(function() {
  if ($(window).scrollTop() > 8) { 
    $('.utillity-bar-main').addClass('open');
  } else {
    $('.utillity-bar-main').removeClass('open');
  }
});


$(document).on('click', '.new-navv-a.header__icon.header__icon--cart.link.focus-inset.site-header-cart--button', function(event) {
    event.preventDefault();
    $('.drawer').addClass('active');
});